import {
    apiTokenService,
    AuthContext,
    getTemplate
} from "@harvestr-api/common";
import { logger } from "@harvestr-api/utils";
import { Request, Response } from "express";
import { OAuth } from "oauth";
import * as url from "url";
import { trelloApiService } from "./trello-api.service";

const trello_requestURL = "https://trello.com/1/OAuthGetRequestToken";
const trello_accessURL = "https://trello.com/1/OAuthGetAccessToken";
const trello_authorizeURL = "https://trello.com/1/OAuthAuthorizeToken";
const trello_appName = "Harvestr Trello Integration";
// You can get your key and secret from Trello at: https://trello.com/app-key
const trello_key = process.env.TRELLO_KEY;
const trello_secret = process.env.TRELLO_OAUTH_SECRET;
// Trello redirects the user here after authentication
const trello_loginCallback = `${
    process.env.H_API_URL || ""
}/authorize/trello/callback`;
const trello_consumer = new OAuth(
    trello_requestURL,
    trello_accessURL,
    trello_key,
    trello_secret,
    "1.0A",
    trello_loginCallback,
    "HMAC-SHA1"
);

export const trelloOauthService = {
    async handleTrelloOauth(req: Request, res: Response) {
        try {
            logger.info(trello_key);
            logger.info(trello_loginCallback);
            console.log(
                "handleTrelloOauth : req.sessionID :",
                (req as any).sessionID
            );
            trello_consumer.getOAuthRequestToken(
                async (error, oauthToken, oauthTokenSecret, results) => {
                    if (error) {
                        throw new Error(error.data);
                    }
                    (<any>req).session.oauth = {
                        oauth_token_secret: oauthTokenSecret,
                        project_id: req.query.id
                    };

                    res.redirect(
                        `${trello_authorizeURL}?scope=read,write,account&expiration=never&oauth_token=${oauthToken}&name=${trello_appName}`
                    );
                }
            );
        } catch (error) {
            logger.error(error);
            res.status(400).send(error);
        }
    },

    async handleTrelloOauthResponse(req: Request, res: Response) {
        try {
            const query: any = url.parse(req.url, true).query || {};
            console.log(
                "handleTrelloOauthResponse : req.sessionID :",
                (req as any).sessionID
            );

            console.log("query :", query);
            // console.log(query);
            const token = query.oauth_token;
            const tokenSecret =
                (req as any)?.session?.oauth?.oauth_token_secret || undefined;
            const verifier = query.oauth_verifier;

            if (tokenSecret === undefined) {
                console.error(
                    "req session is unreachable : please make sure Angular environment DON'T use localhost URLs"
                );
                res.status(200).send(
                    "<h3>Failure ! Please make sure you connect with Trello from the same Harvestr domain all along</h4>"
                );
            } else {
                trello_consumer.getOAuthAccessToken(
                    token,
                    tokenSecret,
                    verifier,
                    async (error, accessToken, accessTokenSecret, results) => {
                        try {
                            if (error) {
                                console.log(
                                    "ERR : ",
                                    JSON.stringify(error, null, 4)
                                );
                                throw new Error(error);
                            }
                            const context: AuthContext = {
                                type: "INTEGRATION_TRELLO",
                                project_id:
                                    (req as any)?.session?.oauth?.project_id ||
                                    undefined
                            };

                            const hasUserRightAccessLevel = await trelloApiService.hasUserRequiredPermissions(
                                context.project_id,
                                accessToken
                            );

                            if (!hasUserRightAccessLevel) {
                                throw new Error("not_enough_permissions");
                            }

                            await apiTokenService.createApiToken(
                                {
                                    source: "TRELLO",
                                    token: accessToken,
                                    token_secret: accessTokenSecret
                                },
                                context
                            );

                            res.status(200).send(
                                "<h3>Success! Redirecting...</h3><h4>You can close this window.</h4>"
                            );
                        } catch (err) {
                            if (err.message === "not_enough_permissions") {
                                res.status(400).send(
                                    getTemplate("trello_not_enough_permissions")
                                );
                            } else {
                                logger.error(err);
                                throw new Error("error getting access token");
                            }
                        }
                    }
                );
            }
        } catch (error) {
            logger.error(error);
            res.status(400).send(error);
        }
    }
};
